import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { CacheService } from './cache.service';

declare const $: any;

/**
 * Define un mensaje
 */
export interface ErrorMessage {
    type: ErrorType;
    body: string;
  }

  /**
   * Tipos de {@link ErrorMessage}s.
   */
  export enum ErrorType {
    DEFAULT,
    DANGER,
    WARNING
  }

  @Injectable()
  export class ErrorMessageService {
    constructor(private sxHttp: SxHttpService, private cacheService: CacheService) {}

setError(f: any) {
    this.cacheService.saveTemp(f, 'error');
}

getError() {
    return this.cacheService.getTemp('error');
}


}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/error.service.ts